import { RoutingConfig } from '@spartacus/core'
import { Routes } from '@angular/router'
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront'
import { MbPoUploadConfirmationPageGuard } from '../../checkout/guards/po-upload-confirmation-page.guard'

export const poUploadRoutingConfig: RoutingConfig = {
  routing: {
    routes: {
      poUpload: { paths: ['support/ordering/purchase-order-upload.html'] },
      poUploadConfirmation: { paths: ['support/ordering/purchase-order-confirmation'] }
    }
  }
}

export const poUploadRoutes: Routes = [
  {
    path: null as any,
    canActivate: [CmsPageGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'poUpload' },
    pathMatch: 'full'
  },
  {
    path: null as any,
    canActivate: [CmsPageGuard, MbPoUploadConfirmationPageGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'poUploadConfirmation' },
    pathMatch: 'full'
  }
]
